import { ICourseInterface } from '../../interfaces/Website/Courses/CoursesCategory/ICoursesCategory'
import apiService from '../Api'

export class CoursesDynamicsService {
  async list(): Promise<ICourseInterface[]> {
    return apiService.get('course/dynamic').then((res) => res.data.areas)
  }

  async create(data: { name: string }) {
    return apiService.post('/course/dynamic', data).then((res) => res.data)
  }

  async update(id: number, data: { name: string }) {
    return apiService.put(`/course/dynamic/${id}`, data).then((res) => res.data)
  }

  async delete(id: number) {
    return apiService.delete(`/course/dynamic/${id}`)
  }
}
